import * as React from 'react';
import { useTranslation } from "react-i18next";
import { Chart, ChartLegend, ChartSeries, ChartSeriesItem, ChartTitle, ChartTooltip } from '@progress/kendo-react-charts';
import 'hammerjs';

export default function FarmInformationComponents(props) {
    const { t } = useTranslation();
    const [farmdashboard, setFarmDashboard] = React.useState({
        "farmId": 0,
        "ordersInProgressCount": 0,
        "ordersWaitingForConfirmationCount": 0,
        "animalsCount": 0,
        "animalsCapacity": 0,
        "storagePointsCapacity": 0,
        "storagePointsVirtualStock": 0,
        "alertStockBreak": "",
        "alertEndingGroup": "",
        "healthStatus": 0,
        "updateDate": ""
    });

    React.useEffect(() => {
        if (props.farmdashboard.farmId !== "") {
            setFarmDashboard({
                "farmId": props.farmdashboard.farmId,
                "ordersInProgressCount": props.farmdashboard.ordersInProgressCount,
                "ordersWaitingForConfirmationCount": props.farmdashboard.ordersWaitingForConfirmationCount,
                "healthStatus": props.farmdashboard.healthStatus,
                "animalsCount": props.farmdashboard.animalsCount,
                "animalsCapacity": props.farmdashboard.animalsCapacity,
                "storagePointsCapacity": props.farmdashboard.storagePointsCapacity,
                "storagePointsVirtualStock": props.farmdashboard.storagePointsVirtualStock,

                "alertStockBreak": props.farmdashboard.alertStockBreak,
                "alertEndingGroup": props.farmdashboard.alertEndingGroup,
                "updateDate": props.farmdashboard.updateDate
            });

        }
    }, [props.farmdashboard]);


    // Calcular ocupación
    const OcupacionNave = farmdashboard.animalsCapacity > 0
        ? ((farmdashboard.animalsCount / farmdashboard.animalsCapacity) * 100)
        : 0;

    const OcupacionSilo = farmdashboard.storagePointsCapacity > 0
        ? ((farmdashboard.storagePointsVirtualStock / farmdashboard.storagePointsCapacity) * 100)
        : 0;

    // Series dinámicas
    const series = [
        { category: t("Global_Label_Text_Filling_Percentage"), value: +OcupacionNave.toFixed(2) },
        { category: t("Global_Label_Text_Emptying_Percentage"), value: +(100 - OcupacionNave).toFixed(2) }
    ];

    const series2 = [
        { category: t("Global_Label_Text_Filling_Percentage"), value: +OcupacionSilo.toFixed(2) },
        { category: t("Global_Label_Text_Emptying_Percentage"), value: +(100 - OcupacionSilo).toFixed(2) }
    ];

    // Tooltip render
    const tooltipRender = (props) => {
        const { category, value } = props.point || {};
        return (
            <div>
                <strong>{t(category)}:</strong> {value}%
            </div>
        );
    };





    return (
        <div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <b>{t("Global_Label_Text_General")}</b>
                    </div>

                    <div className="row no-gutters">
                        <div className="col-md-6 card-body d-flex flex-column align-items-center">
                            <p className="mb-1"><strong>{t("Global_Label_Text_Animals")}</strong>: {farmdashboard.animalsCount}</p>
                            <p className="mb-1"><strong>{t("Global_Label_Text_Occupation_Ships")}(%)</strong>: {OcupacionNave}%</p>
                            <p className="mb-1"><strong>{t("Global_Label_Text_Orders_Pending_Confirmation")}</strong>: {farmdashboard.ordersInProgressCount}</p>
                            <p className="mb-1"><strong>{t("Global_Label_Text_Group_Final")}</strong>: {farmdashboard.alertEndingGroup}</p>
                        </div>

                        <div className="col-md-6 card-body d-flex flex-column align-items-center">
                            <p className="mb-1"><strong>{t("Global_Label_Text_Health_Status")}</strong>: {farmdashboard.healthStatus}</p>
                            <p className="mb-1"><strong>{t("Global_Label_Text_Occupation_Silos")}(%): </strong>{OcupacionSilo}%</p>
                            <p className="mb-1"><strong>{t("Global_Label_Text_Orders_Progress")}</strong>: {farmdashboard.ordersWaitingForConfirmationCount}</p>
                            <p className="mb-1"><strong>{t("Global_Label_Text_Out_Stock")}</strong>: {farmdashboard.alertStockBreak}</p>
                        </div>
                    </div>

                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="card">
                    <div className="card-header">
                        <b>{t("Global_Label_Text_Occupation_Ship")}</b>
                    </div>

                    <div className="row g-3">

                        <div className="col-md-5 col-lg-3 p-4">
                            <div className="card">
                                <div className="card-header">
                                    {series.map((item, index) => (
                                        <div key={index} className="d-flex align-items-center gap-2 mb-1 text-start">
                                            <span className="badge bg-primary">{item.value}</span>
                                            <span>{item.category}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-8">
                            <div className="card-body" style={{ minHeight: '300px' }}>
                                <Chart>
                                    <ChartTitle />
                                    <ChartLegend
                                        position="bottom"
                                        align="end"
                                        orientation="horizontal"
                                        className="mt-3"
                                    />
                                    <ChartTooltip render={tooltipRender} />
                                    <ChartSeries>
                                        <ChartSeriesItem
                                            type="pie"
                                            data={series}
                                            field="value"
                                            categoryField="category"
                                        />
                                    </ChartSeries>
                                </Chart>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="card">
                    <div className="card-header">
                        <b>{t("Global_Label_Text_Employment_Silo")}</b>
                    </div>

                    <div className="row g-3">

                        <div className="col-md-5 col-lg-3 p-4">
                            <div className="card">
                                <div className="card-header">
                                    {series2.map((item, index) => (
                                        <div key={index} className="d-flex align-items-center gap-2 mb-1 text-start">
                                            <span className="badge bg-primary">{item.value}</span>
                                            <span>{item.category}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-8">
                            <div className="card-body" style={{ minHeight: '300px' }}>
                                <Chart>
                                    <ChartTitle />
                                    <ChartLegend
                                        position="bottom"
                                        align="end"
                                        orientation="horizontal"
                                        className="mt-3"
                                    />
                                    <ChartTooltip render={tooltipRender} />
                                    <ChartSeries>
                                        <ChartSeriesItem
                                            type="pie"
                                            data={series2}
                                            field="value"
                                            categoryField="category"
                                        />
                                    </ChartSeries>
                                </Chart>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    );
}